import { createApi } from "@reduxjs/toolkit/dist/query/react";
import ApiService from "./ApiService";
import { baseQuery } from "./basequery";

const servicePrefix = "/logs";

export async function apiListAuditLogs() {
  return ApiService.fetchData({
    url: servicePrefix + '/api_calls/',
    method: "get",
  });
}
export async function apiListActivityLogs() {
  return ApiService.fetchData({
    url: servicePrefix + '/activity/',
    method: "get",
  });
}
export async function apiGetAuditLog(id) {
  return ApiService.fetchData({
    url: servicePrefix + `/search/${id}/`,
    method: "get",
  });
}


export const logServices = createApi({
  reducerPath: "log",
  baseQuery: baseQuery,
  tagTypes: [],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  endpoints: (build) => ({
    getApiLogs: build.query({
      query: ({ ...values }) => ({
        url: servicePrefix + "/api_calls/",
        params: { ...values },
      }),
    }),

    getActivityLogs: build.query({
      query: ({ ...values }) => ({
        url: servicePrefix + "/activity/",
        params: { ...values },
      }),
    }),

    getAuditLog: build.query({
      query: ({ id }) => ({
        url: servicePrefix + `/search/${id}/`,
      }),
    }),
  }),
});


export const { useGetActivityLogsQuery, useGetApiLogsQuery, useGetAuditLogQuery } = logServices;